import React, { useState, useContext, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'
import { mapData } from '@/product/common/components'
import UserContext from '@/product/context/user/userContext'
import AuthContext from '@/product/context/auth/authContext'
import StripeSellerContext from '@/product/context/stripe/seller/sellerContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import * as Yup from 'yup'
import Loaders from '@/custom/components/molecules/Loaders'
import { Button } from '@mui/material'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'

const Payment = (props) => {
    const [paymentModal, setPaymentModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [editPaymentModal, setEditPaymentModal] = useState(false)
    const [editPaymentMethod, setEditPaymentMethod] = useState(null)

    const authContext = useContext(AuthContext)
    const userContext = useContext(UserContext)
    const productCommonContext = useContext(ProductCommonContext)
    const alertContext = useContext(AlertContext)

    const { allCountries, allStates } = productCommonContext
    const { user, loadUser } = authContext
    const { updateProfile, responseStatus: responseStatusUser } = userContext
    const {
        onboardProcess,
        processPayout,
        onboardStatus,
        retrieveAccount,
        seller_details,
        sourceAction,
        // updateBankExternalAccount,
        // updateCardExternalAccount,
        // MakeDefaultExtenalAccount,
        // DeleteExternalAccount,
        responseStatus: responseStatusStripeSeller,
    } = useContext(StripeSellerContext)
    const { setAlert } = alertContext

    const creditCardYearOptions = []
    let date = new Date()
    let currentYear = date.getFullYear()
    let upToYear = parseInt(currentYear) + 25
    for (let year = parseInt(currentYear); year < parseInt(upToYear); year++) {
        creditCardYearOptions.push({
            value: year,
            show: year,
        })
    }
    const creditCardMonthOptions = []
    for (let month = parseInt(1); month <= parseInt(12); month++) {
        let monthValue = ('0' + month).slice(-2)
        creditCardMonthOptions.push({
            value: monthValue,
            show: monthValue,
        })
    }

    useEffect(() => {
        console.log('user', user)
        if (user) {
            if (user?.users_seller_account_status === 'completed') {
                // setIsLoading(true)
                // onboardStatus()
                retrieveAccount()
            } else {
                setIsLoading(false)
            }
        }
    }, [user])

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from === 'updateProfile') {
                if (responseStatusUser.status === 'success') {
                    loadUser()
                }
            }
        }
    }, [responseStatusUser])

    const linkstripe = () => {
        console.log('user admin user', user)
        var data = {
            email: user.emp_email,
            // country: user.emp_country || 'US',
            country: 'US',
            // interval: 'manual',
        }
        onboardProcess(data)
    }
    const checkstripe = () => {
        onboardStatus()
    }

    const validationArray = [
        Yup.object({
            card_number: Yup.string()
                .min(12, 'Invalid credit card number!')
                .max(18, 'Invalid credit card number!')
                .required('Required!'),
            card_name: Yup.string()
                .trim()
                .matches(
                    /^[a-zA-Z\s]*$/g,
                    'The special characters and numbers are not allowed!'
                )
                .required('Required!'),
            card_exp_month: Yup.string().required('Required!'),
            card_exp_year: Yup.string().required('Required!'),
            card_cvc: Yup.string()
                .matches('^[0-9]{3,4}$', 'Invalid CVV!')
                .required('Required!'),
            card_address_line1: Yup.string().required('Required!'),
            card_address_line2: Yup.string(),
            card_address_city: Yup.string().required('Required!'),
            card_address_state: Yup.string().required('Required!'),
            card_address_country: Yup.string().required('Required!'),
            card_address_zip: Yup.string().required('Required!'),
        }),
        Yup.object({
            bank_account_holder_name:
                Yup.string('Must be string').required('Required!'),
            bank_account_number: Yup.number('Number required')
                .positive('Positive Numbers only allowed')
                .required('Required!'),
            bank_account_holder_type: Yup.string().required('Required!'),
            bank_routing_number: Yup.number('Numbers only allowed')
                .positive('Positive Numbers only allowed')
                .required('Required!'),
        }),
    ]

    const formik = useFormik({
        initialValues: {
            payment_method: '2',
        },
        onSubmit: (values) => {
            if (values.payment_method === '1') {
                cardFormik.handleSubmit()
            } else {
                bankFormik.handleSubmit()
            }
        },
    })

    const cardFormik = useFormik({
        initialValues: {
            card_number: '',
            card_name: '',
            card_exp_month: '',
            card_exp_year: '',
            card_cvc: '',
            card_address_line1: '',
            card_address_line2: '',
            card_address_city: '',
            card_address_state: '',
            card_address_zip: '',
            card_address_country: 'US',
            card_token: true,
        },
        validationSchema: validationArray[0],
        onSubmit: (values) => {
            processPayout(values)
        },
    })

    const bankFormik = useFormik({
        initialValues: {
            bank_country: 'US',
            bank_currency: 'USD',
            bank_account_holder_name: '',
            bank_account_holder_type: '',
            bank_routing_number: '',
            bank_account_number: '',
            bank_token: true,
        },
        validationSchema: validationArray[1],
        onSubmit: (values) => {
            processPayout(values)
        },
    })

    const resetCard = () => {
        cardFormik.values.card_number = ''
        cardFormik.values.card_name = ''
        cardFormik.values.card_exp_month = ''
        cardFormik.values.card_exp_year = ''
        cardFormik.values.card_cvc = ''
        cardFormik.values.card_address_line1 = ''
        cardFormik.values.card_address_line2 = ''
        cardFormik.values.card_address_city = ''
        cardFormik.values.card_address_state = ''
        cardFormik.values.card_address_zip = ''
        cardFormik.values.card_address_country = 'US'
    }

    const resetBank = () => {
        bankFormik.values.bank_account_holder_name = ''
        bankFormik.values.bank_account_holder_type = ''
        bankFormik.values.bank_routing_number = ''
        bankFormik.values.bank_account_number = ''
    }

    useEffect(() => {
        if (responseStatusStripeSeller) {
            if (responseStatusStripeSeller.from === 'onboardProcess') {
                if (responseStatusStripeSeller.status === 'success') {
                    if (responseStatusStripeSeller.type === 6) {
                        const newWindow = window.open(
                            `${responseStatusStripeSeller.data.url}`,
                            '_self'
                        )
                    }
                }
            }
        }
    }, [responseStatusStripeSeller])

    useEffect(() => {
        if (responseStatusStripeSeller) {
            console.log(
                'responseStatusStripeSeller',
                responseStatusStripeSeller
            )
            if (responseStatusStripeSeller.status === 'success') {
                if (responseStatusStripeSeller.from === 'onboardStatus') {
                    if (responseStatusStripeSeller.type) {
                        if (responseStatusStripeSeller.type === 6) {
                            if (responseStatusStripeSeller.type === 6) {
                                window.open(
                                    `${responseStatusStripeSeller.data.url}`,
                                    '_self'
                                )
                            }
                        } else if (responseStatusStripeSeller.type === 7) {
                            loadUser()
                        } else {
                            loadUser()
                        }
                    } else {
                        handleRedirectInternal(history, '')
                    }
                    setIsLoading(false)
                    setPaymentModal(false)
                } else if (
                    responseStatusStripeSeller.from === 'onboardProcess' ||
                    responseStatusStripeSeller.from === 'sourceAction' ||
                    responseStatusStripeSeller.from === 'processPayout'
                ) {
                    retrieveAccount()
                    resetCard()
                    resetBank()
                    setEditPaymentModal(false)
                    setPaymentModal(false)
                }
            } else {
                setAlert(responseStatusStripeSeller.message, 'error')
            }
        }
    }, [responseStatusStripeSeller])
    const paymentMethod = {
        formik: formik,
        data: [
            {
                title: 'Select a payment method',
                type: 'radio',
                name: 'payment_method',
                int: 1,
                class: 'col-12',
                item: [
                    { id: 1, description: 'Card' },
                    { id: 2, description: 'Bank Account' },
                ],
            },
        ],
    }

    const editCardValidation = Yup.object({
        name: Yup.string()
            .trim()
            .matches(
                /^[a-zA-Z\s]*$/g,
                'The special characters and numbers are not allowed!'
            )
            .required('Required!'),
        exp_month: Yup.string().required('Required!'),
        exp_year: Yup.string().required('Required!'),
        address_line1: Yup.string().required('Required!'),
        address_line2: Yup.string().nullable(),
        address_city: Yup.string().required('Required!'),
        address_state: Yup.string().required('Required!'),
        address_country: Yup.string().required('Required!'),
        address_zip: Yup.string().required('Required!'),
    })

    const editCardFormik = useFormik({
        initialValues: {
            source: '',
            name: '',
            exp_month: '',
            exp_year: '',
            address_line1: '',
            address_line2: '',
            address_city: '',
            address_state: '',
            address_zip: '',
            address_country: '',
            card_token: true,
            action: 'update',
        },
        validationSchema: editCardValidation,
        onSubmit: (values) => {
            console.log('card values', values)
            sourceAction(values)
        },
    })

    const editBankValidation = Yup.object({
        account_holder_name: Yup.string('Must be string').required('Required!'),
        account_holder_type: Yup.string().required('Required!'),
    })

    const editBankFormik = useFormik({
        initialValues: {
            source: '',
            account_holder_name: '',
            account_holder_type: '',
            bank_token: true,
            action: 'update',
        },
        validationSchema: editBankValidation,
        onSubmit: (values) => {
            console.log('bankdd', values)
            sourceAction(values)
        },
    })

    // const cards = [
    //     { brand: 'visa', last4: '1245', exp_month: '02', exp_year: '2092', name: 'Areef Syed' },
    //     { brand: 'visa', last4: '1245', exp_month: '02', exp_year: '2092', name: 'Areef Syed' },
    // ]

    const handleBankEdit = (data) => {
        setEditPaymentModal(true)
        setEditPaymentMethod('bank')
        editBankFormik.values.account_holder_name = data.account_holder_name
        editBankFormik.values.account_holder_type = data.account_holder_type
        editBankFormik.values.source = data.id
    }

    const handleCardEdit = (data) => {
        setEditPaymentModal(true)
        setEditPaymentMethod('card')
        editCardFormik.values.name = data.name
        editCardFormik.values.exp_month = data.exp_month
        editCardFormik.values.exp_year = data.exp_year
        editCardFormik.values.address_line1 = data.address_line1
        editCardFormik.values.address_line2 = data.address_line2
        editCardFormik.values.address_city = data.address_city
        editCardFormik.values.address_state = data.address_state
        editCardFormik.values.address_zip = data.address_zip
        editCardFormik.values.address_country = data.address_country
        editCardFormik.values.source = data.id
    }

    const handleDelete = (data) => {
        sourceAction({
            source: data.id,
            action: 'delete',
        })
    }

    const handleDefaultSource = (data) => {
        sourceAction({
            source: data.id,
            action: 'default',
        })
    }

    const cardDetails = {
        formik: cardFormik,
        data: [
            {
                label: 'Card Holder Name',
                type: 'text',
                placeholder: 'Enter your card holder name',
                class: 'col-12',
                name: 'card_name',
            },
            {
                label: 'Card No',
                type: 'number',
                placeholder: 'Enter your card no',
                class: 'col-12',
                name: 'card_number',
            },
            {
                label: 'Expiry Month',
                placeholder: 'MM',
                class: 'col-md-4 col-12',
                type: 'select',
                name: 'card_exp_month',
                options: creditCardMonthOptions,
            },
            {
                label: 'Expiry Year',
                placeholder: 'YYYY',
                class: 'col-md-4 col-12',
                type: 'select',
                name: 'card_exp_year',
                options: creditCardYearOptions,
            },
            {
                label: 'CVV',
                type: 'text',
                placeholder: 'Enter your CVV',
                class: 'col-md-4 col-12',
                name: 'card_cvc',
            },
            {
                label: 'Address line 1',
                type: 'text',
                placeholder: 'Enter address line 1',
                class: 'col-12',
                name: 'card_address_line1',
            },
            {
                label: 'Address line 2',
                type: 'text',
                placeholder: 'Enter address line 2',
                class: 'col-12',
                name: 'card_address_line2',
            },
            {
                label: 'City',
                type: 'text',
                placeholder: 'Enter your city',
                class: 'col-12 billingAdd',
                name: 'card_address_city',
            },

            {
                label: 'State',
                type: 'select',
                placeholder: 'Select your state',
                class: 'col-12',
                options: allStates
                    .filter(
                        (state) =>
                            (cardFormik.values.card_address_country
                                ? cardFormik.values.card_address_country.indexOf(
                                      state.countryCode
                                  ) !== -1
                                : global.defaultCountry.indexOf(
                                      state.countryCode
                                  ) !== -1) &&
                            global.ignoreStates.indexOf(state.isoCode) === -1
                    )
                    .map((buscat) => {
                        let busCategoryChanged = {}
                        busCategoryChanged.show = buscat.name
                        busCategoryChanged.value = buscat.isoCode
                        return busCategoryChanged
                    }),
                name: 'card_address_state',
            },
            {
                label: 'Country',
                placeholder: 'Select your country',
                class: 'col-12',
                type: 'select',
                options: allCountries
                    ? allCountries.map((country) => {
                          let busCategoryChanged = {}
                          busCategoryChanged.show = country.name
                          busCategoryChanged.value = country.isoCode
                          return busCategoryChanged
                      })
                    : [],
                name: 'card_address_country',
            },
            {
                label: 'Zip',
                type: 'text',
                placeholder: 'Enter your zip code',
                class: 'col-12',
                name: 'card_address_zip',
            },
        ],
    }

    const editCardDetails = {
        formik: editCardFormik,
        data: [
            {
                label: 'Card Holder Name',
                type: 'text',
                placeholder: 'Enter your card holder name',
                class: 'col-12',
                name: 'name',
            },
            {
                label: 'Expiry Month',
                placeholder: 'MM',
                class: 'col-md-4 col-12',
                type: 'select',
                name: 'exp_month',
                options: creditCardMonthOptions,
            },
            {
                label: 'Expiry Year',
                placeholder: 'YYYY',
                class: 'col-md-4 col-12',
                type: 'select',
                name: 'exp_year',
                options: creditCardYearOptions,
            },
            {
                label: 'Billing address line 1',
                type: 'text',
                placeholder: 'Enter billing address line1',
                class: 'col-12',
                name: 'address_line1',
            },
            {
                label: 'Billing address line 2',
                type: 'text',
                placeholder: 'Enter billing address line2',
                class: 'col-12',
                name: 'address_line2',
            },
            {
                label: 'Billing city',
                type: 'text',
                placeholder: 'Enter billing address city',
                class: 'col-12 billingAdd',
                name: 'address_city',
            },

            {
                label: 'Billing state',
                type: 'select',
                placeholder: 'Select billing address state',
                class: 'col-12',
                options: allStates
                    .filter(
                        (state) =>
                            (cardFormik.values.card_address_country
                                ? cardFormik.values.card_address_country.indexOf(
                                      state.countryCode
                                  ) !== -1
                                : global.defaultCountry.indexOf(
                                      state.countryCode
                                  ) !== -1) &&
                            global.ignoreStates.indexOf(state.isoCode) === -1
                    )
                    .map((buscat) => {
                        let busCategoryChanged = {}
                        busCategoryChanged.show = buscat.name
                        busCategoryChanged.value = buscat.isoCode
                        return busCategoryChanged
                    }),
                name: 'address_state',
            },
            {
                label: 'Billing country',
                placeholder: 'Select billing address country',
                class: 'col-12',
                type: 'select',
                options: allCountries
                    ? allCountries.map((country) => {
                          let busCategoryChanged = {}
                          busCategoryChanged.show = country.name
                          busCategoryChanged.value = country.isoCode
                          return busCategoryChanged
                      })
                    : [],
                name: 'address_country',
            },
            {
                label: 'Billing zip/postal code',
                type: 'text',
                placeholder: 'Enter billing zip/postal code',
                class: 'col-12',
                name: 'address_zip',
            },
        ],
    }

    const bankDetails = {
        formik: bankFormik,
        data: [
            {
                label: 'Account Holder Name',
                type: 'text',
                placeholder: 'Enter account holder name',
                class: 'col-12',
                name: 'bank_account_holder_name',
                autoFocus: true,
            },
            {
                label: 'Account Number',
                type: 'string',
                placeholder: 'Enter account number',
                name: 'bank_account_number',
                class: 'col-12',
            },
            {
                label: 'Account Type',
                type: 'select',
                options: [
                    {
                        show: 'Individual',
                        value: 'individual',
                    },
                    {
                        show: 'Company',
                        value: 'company',
                    },
                ],
                placeholder: 'Enter account holder type',
                class: 'col-12',
                name: 'bank_account_holder_type',
            },
            {
                label: 'Routing Number',
                type: 'string',
                placeholder: 'Enter routing number',
                class: 'col-12',
                name: 'bank_routing_number',
            },
        ],
    }

    const editBankDetails = {
        formik: editBankFormik,
        data: [
            {
                label: 'Account Holder Name',
                type: 'text',
                placeholder: 'Enter account holder name',
                class: 'col-12',
                name: 'account_holder_name',
                autoFocus: true,
            },
            {
                label: 'Account Type',
                type: 'select',
                options: [
                    {
                        show: 'Individual',
                        value: 'individual',
                    },
                    {
                        show: 'Company',
                        value: 'company',
                    },
                ],
                placeholder: 'Enter account holder type',
                class: 'col-12',
                name: 'account_holder_type',
            },
        ],
    }
    return (
        <Layout>
            <>
                {isLoading ? (
                    <div className="noGrid">
                        <Loaders isLoading={isLoading} loop={1} />
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-12">
                            {!user?.users_seller_account_status ||
                            user?.users_seller_account_status == '' ? (
                                <div className="paymentActBanner">
                                    <div className="stripeInfo inactive">
                                        <div>
                                            <img
                                                src="/assets/images/payout/error.png"
                                                alt="Error"
                                            />
                                            <div>
                                                <h4>
                                                    Your Payout account
                                                    isn&apos;t linked with
                                                    Stripe yet.
                                                </h4>
                                                <h6>
                                                    Please link your Stripe
                                                    account to setup an account.
                                                </h6>
                                            </div>
                                        </div>
                                        <PrimaryButton
                                            type="submit"
                                            onClick={(e) => linkstripe()}
                                            label="Link Stripe"
                                        />
                                        <br />
                                        <SecondaryButton
                                            type="submit"
                                            onClick={(e) => checkstripe()}
                                            label="Check Status"
                                        />
                                    </div>
                                </div>
                            ) : user?.users_seller_account_status ==
                              'onboarding' ? (
                                <div className="paymentActBanner">
                                    <div className="stripeInfo partial">
                                        <div>
                                            <img
                                                src="/assets/images/payout/stripeSetup.png"
                                                alt="Stripe Setup"
                                            />
                                            <div>
                                                <h4>
                                                    Your Payout account
                                                    isn&apos;t set up.
                                                </h4>
                                                <h6>
                                                    Please set up your Stripe
                                                    account to receive payout.
                                                </h6>
                                            </div>
                                        </div>
                                        <PrimaryButton
                                            type="submit"
                                            onClick={(e) => checkstripe()}
                                            label="connect stripe"
                                        />
                                        <br />
                                        <SecondaryButton
                                            type="submit"
                                            onClick={(e) => checkstripe()}
                                            label="Check Status"
                                        />
                                    </div>
                                </div>
                            ) : user?.users_seller_account_status ===
                              'payout_pending' ? (
                                <>
                                    <div className="noPayment">
                                        <div className="noPaymentInner">
                                            <img
                                                src="/assets/images/payout/addCard.png"
                                                alt="Add card"
                                            />
                                            <div>
                                                <h4>
                                                    You have not added any
                                                    payment method yet.
                                                </h4>
                                                <h6>
                                                    To receive payments from
                                                    your customer you need to
                                                    add a Bank Account or a
                                                    Debit Card.
                                                </h6>
                                            </div>
                                        </div>
                                        <PrimaryButton
                                            label="Add a payment method"
                                            onClick={() =>
                                                setPaymentModal(true)
                                            }
                                        />
                                        <br />
                                        <SecondaryButton
                                            type="submit"
                                            onClick={(e) => checkstripe()}
                                            label="Check Status"
                                        />
                                    </div>
                                </>
                            ) : user?.users_seller_account_status ===
                              'completed' ? (
                                <p className="stripeInfo active">
                                    <span className="material-icons">
                                        check_circle
                                    </span>
                                    You are successfully linked your Stripe
                                    account.{' '}
                                    {/* Your account ID
                                    is: {user?.seller_account_id}. */}
                                </p>
                            ) : null}
                        </div>
                    </div>
                )}

                {/* {seller_details?.external_accounts?.total_count == 1 &&
                    seller_details?.external_accounts?.total_count < 2 && (
                        <SecondaryButton
                            btnSize="addPayBtn"
                            label="Add another payment method"
                            onClick={() => setPaymentModal(true)}
                        />
                    )} */}
                <div
                    className={`dashboardInner payout ${
                        user?.users_seller_account_status == '' ||
                        user?.users_seller_account_status == 'onboarding' ||
                        user?.users_seller_account_status === 'payout_pending'
                            ? 'p-0'
                            : ''
                    }`}
                >
                    {seller_details?.external_accounts?.total_count >= 1 && (
                        <div className="savedCardsCnt">
                            <div className="savedCardTitleCnt">
                                <h3 className="savedCardTitle">
                                    Saved Bank/Card Details
                                </h3>
                                {/* {seller_details?.external_accounts
                                    ?.total_count == 1 &&
                                    seller_details?.external_accounts
                                        ?.total_count < 2 && (
                                        <Button
                                            className="addPayBtn"
                                            variant="outlined"
                                            onClick={() =>
                                                setPaymentModal(true)
                                            }
                                        >
                                            Add a new payment method
                                        </Button>
                                    )} */}
                            </div>

                            <div className="savedCards">
                                {seller_details?.external_accounts &&
                                    seller_details?.external_accounts?.data.map(
                                        (data, index) => (
                                            <>
                                                {data?.object ==
                                                'bank_account' ? (
                                                    <div
                                                        className={`bankCard d-flex justify-content-between flex-column`}
                                                        key={index}
                                                    >
                                                        {data.default_for_currency ==
                                                        true ? (
                                                            <h5 className="defaultCard">
                                                                Default
                                                            </h5>
                                                        ) : (
                                                            ''
                                                        )}
                                                        <div className="bankInfo">
                                                            <h2>
                                                                **** **** ****{' '}
                                                                {data.last4}
                                                            </h2>
                                                        </div>
                                                        <div className="bankInfo">
                                                            <h2>
                                                                {
                                                                    data.account_holder_name
                                                                }
                                                            </h2>
                                                        </div>
                                                        <div className="bankInfo">
                                                            <h2>
                                                                {data.bank_name}
                                                            </h2>
                                                        </div>

                                                        <div className="cardActions">
                                                            <div className="cardActionsTop">
                                                                {' '}
                                                                <Button
                                                                    className="edit"
                                                                    onClick={() =>
                                                                        handleBankEdit(
                                                                            data
                                                                        )
                                                                    }
                                                                >
                                                                    <span className="material-icons">
                                                                        edit
                                                                    </span>
                                                                    Edit
                                                                </Button>
                                                                {!(
                                                                    data.default_for_currency ==
                                                                    true
                                                                ) && (
                                                                    <>
                                                                        <Button
                                                                            className="delete"
                                                                            onClick={() =>
                                                                                handleDelete(
                                                                                    data
                                                                                )
                                                                            }
                                                                        >
                                                                            <span className="material-icons">
                                                                                delete
                                                                            </span>
                                                                            Delete
                                                                        </Button>
                                                                    </>
                                                                )}
                                                            </div>
                                                            {!(
                                                                data.default_for_currency ==
                                                                true
                                                            ) && (
                                                                <>
                                                                    <Button
                                                                        className="default"
                                                                        onClick={() =>
                                                                            handleDefaultSource(
                                                                                data
                                                                            )
                                                                        }
                                                                    >
                                                                        <span className="material-icons">
                                                                            check_circle
                                                                        </span>
                                                                        Make
                                                                        Default
                                                                    </Button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className={`credCard d-flex justify-content-between flex-column`}
                                                        key={index}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <img src="/assets/images/payout/hologram.png" />
                                                            {data.brand}
                                                        </div>
                                                        <div className="credCardNum">
                                                            <h2>
                                                                **** **** ****{' '}
                                                                {data.last4}
                                                            </h2>
                                                        </div>
                                                        <div
                                                            className={`credCardName d-flex justify-content-between align-items-center`}
                                                        >
                                                            <div className="text-left">
                                                                <span>
                                                                    CARD HOLDER
                                                                </span>
                                                                <p>
                                                                    {
                                                                        data.account_holder_name
                                                                    }
                                                                </p>
                                                            </div>

                                                            <div className="text-left">
                                                                <span>
                                                                    EXPIRES
                                                                </span>
                                                                <p>
                                                                    {data.exp_month +
                                                                        '/' +
                                                                        data.exp_year}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className={`cardActions d-flex justify-content-end align-items-center`}
                                                        >
                                                            <Button
                                                                className="edit"
                                                                onClick={() =>
                                                                    handleCardEdit(
                                                                        data
                                                                    )
                                                                }
                                                            >
                                                                <span className="material-icons">
                                                                    edit
                                                                </span>
                                                                Edit
                                                            </Button>

                                                            {!(
                                                                data.default_for_currency ==
                                                                true
                                                            ) && (
                                                                <Button
                                                                    className="default"
                                                                    onClick={() =>
                                                                        handleDefaultSource(
                                                                            data
                                                                        )
                                                                    }
                                                                >
                                                                    <span className="material-icons">
                                                                        check_circle
                                                                    </span>
                                                                    Make Default
                                                                </Button>
                                                            )}

                                                            <Button
                                                                className="delete"
                                                                onClick={() =>
                                                                    handleDelete(
                                                                        data
                                                                    )
                                                                }
                                                            >
                                                                <span className="material-icons">
                                                                    delete
                                                                </span>
                                                                Delete
                                                            </Button>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )
                                    )}
                            </div>
                        </div>
                    )}
                </div>
            </>

            <CustomDialog
                open={paymentModal}
                size="md"
                function={() => setPaymentModal(false)}
                modaltitle="Add Payment Method"
                className="paymentModal"
            >
                <div className={`paymentModal row`}>
                    {mapData(paymentMethod)}

                    {formik.values.payment_method == 2 ? (
                        <>
                            {mapData(bankDetails)}

                            <div className="col-12">
                                <PrimaryButton
                                    onClick={(e) => bankFormik.handleSubmit(e)}
                                    label="Save"
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            {mapData(cardDetails)}
                            <div className="col-12">
                                <PrimaryButton
                                    onClick={(e) => cardFormik.handleSubmit(e)}
                                    label="Save"
                                />
                            </div>
                        </>
                    )}
                </div>
            </CustomDialog>

            <CustomDialog
                open={editPaymentModal}
                size="md"
                function={() => setEditPaymentModal(false)}
                modaltitle="Edit Payment Method"
                className="paymentModal"
            >
                <div className={`paymentModal row`}>
                    {/* <MapData formik={formik} data={paymentMethod} /> */}
                    {editPaymentMethod == 'bank' ? (
                        <>
                            {mapData(editBankDetails)}

                            <div className="col-12">
                                <PrimaryButton
                                    onClick={(e) =>
                                        editBankFormik.handleSubmit(e)
                                    }
                                    label="Save"
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            {mapData(editCardDetails)}

                            <div className="col-12">
                                <PrimaryButton
                                    onClick={(e) =>
                                        editCardFormik.handleSubmit(e)
                                    }
                                    label="Save"
                                />
                            </div>
                        </>
                    )}
                </div>
            </CustomDialog>
        </Layout>
    )
}

export default Payment
